import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=502ba383&"
import script from "./ProductVariations.vue?vue&type=script&lang=js&"
export * from "./ProductVariations.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariations.vue?vue&type=style&index=0&id=502ba383&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports